import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { SummaryActions } from './summary.actions';

@Injectable({
  providedIn: 'root'
})
export class SummaryEffects {
  sendSummaryEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendSummaryEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(SummaryActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
